import React, { useEffect, useState } from "react";
import DTOTransferARModal from "./DTOTransferARModal";
import TransferARModalPresenter from "./TransferARModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";
import { claimService } from "../../../../api/services/claimService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
}

const TransferARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const [allActionsData, setAllActionsData] = useState([]);
  const { t } = useTranslation();

  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOTransferARModal
        setAllActions={(actions: any) => setAllActionsData(actions)}
      />

      <TransferARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        userId={selector.user_id}
        fullData={fullData}
        allActionsData={allActionsData}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default TransferARModalController;
